<template>
  <div id="marketing">
    <section class="section bg-secondary">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6" data-aos="fade-up" data-aos-duration="1300">
            <div class="card bg-default shadow border-0">
              <img
                v-lazy="'img/theme/circule.webp'"
                alt="vélo publicitaire au bénin panneau mobile. Street marketing with an advertising bike. Bénin Régie publicitaire"
                class="card-img-top"
              />
              <blockquote class="card-blockquote">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="svg-bg"
                >
                  <polygon
                    points="0,52 583,95 0,95"
                    class="fill-default"
                  ></polygon>
                  <polygon
                    points="0,42 583,95 683,0 0,95"
                    opacity=".2"
                    class="fill-default"
                  ></polygon>
                </svg>
                <h4 class="display-3 font-weight-bold text-white">Suivie</h4>
                <p class="lead text-italic text-white">
                  Chez Panneau Mobile, nous accordons une importance
                  particulière à la qualité des campagnes de communication que
                  nous réalisons mais surtout aux retours que vous aurez après
                  une campagne d’affichage mobile ou une activité street
                  marketing.
                </p>
              </blockquote>
            </div>
          </div>

          <div class="col-md-6" data-aos="fade-up" data-aos-duration="1000">
            <div class="pl-md-5">
              <icon
                name="ni ni-map-big"
                class="mb-5"
                size="lg"
                type="success"
                shadow
                rounded
              ></icon>

              <h3>Campagnes locales</h3>
              <p class="lead">
                Le vélo publicitaire est parfaitement adapté à vos campagnes de
                communication locales, multi-villes et nationales.
              </p>
              <p>
                De nombreux réseaux de points de vente, promoteurs immobiliers,
                entreprises, commerçants, artisants, concessions automobiles et
                institutionnelles utilisent ce format d’affichage mobile pour
                développer leur notoriété au niveau local et créer du Drive to
                Store.
              </p>
              <p>
                Nous adaptons systématiquement l’itinéraire de nos campagnes
                locales pour optimiser la couverture de votre zone de chalandise
                / commercialisation. Pour une parfaite maitrise opérationnelle
                et une production simultanée.
              </p>
              <base-button
                class="btn-1"
                type="success"
                @click="$router.push('contact')"
                >Demandez un devis</base-button
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <img
      src="img/theme/celtiis/IMG_6928j.jpg"
      alt="vélo publicitaire au bénin panneau mobile. Street marketing with an advertising bike. Bénin Régie publicitaire"
      class="bande"
    />
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  methods: {
    suivant() {
      this.$emit("oga", true);
    },
  },
};
</script>
<style scoped>
.bande {
  object-fit: cover !important;
  height: 800px;
  width: 100%;
}
.bane {
  object-fit: cover !important;
  height: 500px;
  width: 27%;
  background-position: center;
}

@media screen and (min-width: 701px) and (max-width: 1440px) {
  .bande {
    height: 500px;
  }
}
@media screen and (max-width: 700px) {
  .bane,
  .bande {
    object-fit: cover !important;
    height: 200px;
    width: 100%;
    background-position: center;
  }
  .journal {
    height: 450px;
  }
}
</style>
